import { z } from 'zod';

import { shared } from '@tig-dpqa-cloud/contract-backend-common';

export const DataplaneConfigCredentials = shared.AWSCredentials.extend({
  secretName: z.string().min(1).describe('Name of the secret to upload the config to'),
  secretArn: z.string().optional().describe('ARN of the secret to upload the config to'),
});

export type DataplaneConfigCredentials = z.infer<typeof DataplaneConfigCredentials>;
